import { ContextCodes } from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import { useHistory, useLocation } from "react-router-dom";
import { AuthXService } from "@brg/auth";
import { useMemo } from "react";
import { AppTester } from "../../../../supporting";

const CONTINUUM_SITE_URL = "https://continuum.site";

interface UseGetNewContextsLinksProps {
  onlyMediiia?: boolean;
  excludeIds?: string[];
}

export const useGetNewContextsLinks = (props?: UseGetNewContextsLinksProps) => {
  const { onlyMediiia = false, excludeIds } = props || {};
  const {
    isDeziiignMain,
    isFashionDeziiign,
    isGameDeziiign,
    isProDeziiign,
    isMediiiaUrban,
    isMediiia,
    isContinuumSite,
    isBrnd,
    isAcademy,
    isNewDafesSegment,
  } = useAppTester();


  const isMediaCtxs =
    AppTester.isContext("creativemediiia") ||
    AppTester.isContext("historymediiia") ||
    AppTester.isContext("profmediiia") ||
    AppTester.isContext("gamemediiia") ||
    AppTester.isContext("cinemediiia") ||
    AppTester.isContext("aimediiia") ||
    AppTester.isContext("sportmediiia") ||
    AppTester.isContext("eventmediiia") ||
    AppTester.isContext("transfermediiia") ||
    AppTester.isContext("musicmediiia") ||
    AppTester.isContext("storiesmediiia") ||
    AppTester.isContext("artmediiia") ||
    AppTester.isContext("fairmediiia") ||
    AppTester.isContext("admediiia") ||
    AppTester.isContext("kiiidsmediiia") ||
    AppTester.isContext("automediiia") ||
    AppTester.isContext("designmediiia") ||
    AppTester.isContext("urbanmediiia") ||
    AppTester.isContext("fashionmediiia") ||
    AppTester.isContext("foodmediiia") ||
    AppTester.isContext("booksmediiia") ||
    AppTester.isContext("lmsmediiia") ||
    AppTester.isContext("naturemediiia") ||
    AppTester.isContext("conceptmediiia") ||
    AppTester.isContext("mymediiia");

  const isMediiiaMain = isMediiia && !isMediaCtxs;
  const isMyMediiia = AppTester.isMyMediiia();
  const isLectureMediiia = AppTester.isLectureMediiia();

  const {
    REACT_APP_URL_DEZIIIGN,
    REACT_APP_URL_DEZIIIGN_FASHION_COM,
    REACT_APP_URL_DEZIIIGN_GAME_COM,
    REACT_APP_URL_DEZIIIGN_PRO_COM,
    REACT_APP_URL_DEZIIIGN_URBAN_COM,
    REACT_APP_URL_MEDIIIA_COM,
    REACT_APP_URL_EDUCATION_MEDIIIA_COM,
    REACT_APP_URL_MY_MEDIIIA_COM,
    REACT_APP_URL_SPORT_MEDIIIA_COM,
    REACT_APP_URL_DAFES,
    REACT_APP_URL_CREATIVE_CITY,
    REACT_APP_URL_GALLERY,
  } = process.env;

  const suffix = AuthXService.isAuthenticated()
    ? "?shouldLogin=true&saveLoginUrl=true"
    : "";
  const history = useHistory();
  const { pathname } = useLocation();

  const baseURL = REACT_APP_URL_MEDIIIA_COM || "";
  const educationUrl = REACT_APP_URL_EDUCATION_MEDIIIA_COM || "";
  const myMediiiaUrl = REACT_APP_URL_MY_MEDIIIA_COM || "";
  const sportMediiiaUrl = REACT_APP_URL_SPORT_MEDIIIA_COM || "";
  const mediaMainTab = sessionStorage.getItem('mediaMainTab')
  const links = useMemo(() => {
    const mediiiaLinks = [
      {
        id: ContextCodes.hseDesignMain,
        active: ["/", "/portfolio"].includes(pathname) && isMediiiaMain,
        content: "main",
        linkTo: "/",
        action: () => {
          if (isMediiiaMain && !mediaMainTab) {
            history.push("/");
            return;
          }
          if (isMediiiaMain && mediaMainTab) {
            window.location.href = `/?tab=${mediaMainTab}`;
            return;
          }
          if (mediaMainTab) {
                window.open(baseURL + `/?tab=${mediaMainTab}`, "_self");
                return;
          }
          window.open(baseURL + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: isMyMediiia,
        content: "my",
        linkTo: `${myMediiiaUrl}`,
        action: () => {
          window.open(myMediiiaUrl + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: true,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("artmediiia") || AppTester.isContext("fairmediiia"),
        content: "art",
        linkTo: `${baseURL}/art`,
        action: () => {
          window.open(baseURL + "/art", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("historymediiia"),
        content: "history",
        linkTo: `${baseURL}/history`,
        action: () => {
          window.open(baseURL + "/history", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("booksmediiia"),
        content: "books",
        linkTo: `${baseURL}/books`,
        action: () => {
          window.open(baseURL + "/books", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("musicmediiia"),
        content: "sound",
        linkTo: `${baseURL}/sound`,
        action: () => {
          window.open(baseURL + "/sound", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("cinemediiia"),
        content: "cine",
        linkTo: `${baseURL}/cine`,
        action: () => {
          window.open(baseURL + "/cine", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("admediiia"),
        content: "advert",
        linkTo: `${baseURL}/advert`,
        action: () => {
          window.open(baseURL + "/advert", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("conceptmediiia"),
        content: "concept",
        linkTo: `${baseURL}/concept`,
        action: () => {
          window.open(baseURL + "/concept", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("sportmediiia"),
        content: "sport",
        linkTo: `${sportMediiiaUrl}`,
        action: () => {
          window.open(sportMediiiaUrl + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: true,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("eventmediiia"),
        content: "365",
        linkTo: `${baseURL}/365`,
        action: () => {
          window.open(baseURL + "/365", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("naturemediiia"),
        content: "astro",
        linkTo: `${baseURL}/astro`,
        action: () => {
          window.open(baseURL + "/astro", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("foodmediiia"),
        content: "food",
        linkTo: `${baseURL}/food`,
        action: () => {
          window.open(baseURL + "/food", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("automediiia"),
        content: "auto",
        linkTo: `${baseURL}/auto`,
        action: () => {
          window.open(baseURL + "/auto", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("storiesmediiia"),
        content: "stories",
        linkTo: `${baseURL}/stories`,
        action: () => {
          window.open(baseURL + "/stories", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: isLectureMediiia,
        content: "education",
        linkTo: `${educationUrl}`,
        action: () => {
          window.open(educationUrl + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: true,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("aimediiia"),
        content: "ai",
        linkTo: `${baseURL}/ai`,
        action: () => {
          window.open(baseURL + "/ai", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("kiiidsmediiia"),
        content: "kiiids",
        linkTo: `${baseURL}/kiiids`,
        action: () => {
          window.open(baseURL + "/kiiids" + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("profmediiia"),
        content: "work",
        linkTo: `${baseURL}/work`,
        action: () => {
          window.open(baseURL + "/work", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
    ];

    const deziiignLinks = [
      {
        id: ContextCodes.deziiignMain,
        active: isDeziiignMain,
        content: "deziiign",
        importantTitle: "mediiia",
        linkTo: (REACT_APP_URL_DEZIIIGN || "") + suffix,
        action: () => {
          if (isDeziiignMain) {
            history.push("/");
            return;
          }
          window.open((REACT_APP_URL_DEZIIIGN || "") + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
      },
      {
        id: ContextCodes.fashionDeziiign,
        active: isFashionDeziiign,
        content: "fashion",
        linkTo: (REACT_APP_URL_DEZIIIGN_FASHION_COM || "") + suffix,
        action: () => {
          if (isFashionDeziiign) {
            history.push("/");
            return;
          }
          window.open((REACT_APP_URL_DEZIIIGN_FASHION_COM || "") + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("urbanmediiia"),
        content: "urban",
        linkTo: (REACT_APP_URL_DEZIIIGN_URBAN_COM || "") + suffix,
        action: () => {
          if (isMediiiaUrban) {
            history.push("/");
            return;
          }
          window.open((REACT_APP_URL_DEZIIIGN_URBAN_COM || "") + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
      },
      {
        id: ContextCodes.gameDeziiign,
        active: isGameDeziiign,
        content: "game",
        linkTo: (REACT_APP_URL_DEZIIIGN_GAME_COM || "") + suffix,
        action: () => {
          if (isGameDeziiign) {
            history.push("/");
            return;
          }
          window.open((REACT_APP_URL_DEZIIIGN_GAME_COM || "") + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
      },
      {
        id: ContextCodes.proDeziiign,
        active: isProDeziiign,
        content: "pro",
        linkTo: (REACT_APP_URL_DEZIIIGN_PRO_COM || "") + suffix,
        action: () => {
          if (isProDeziiign) {
            history.push("/");
            return;
          }
          window.open((REACT_APP_URL_DEZIIIGN_PRO_COM || "") + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
      },
    ];

    const tailLinks = [
      {
        id: ContextCodes.hseVisualResearch,
        active: isContinuumSite,
        content: "continuum",
        linkTo: CONTINUUM_SITE_URL,
        action: () => {
          window.open(CONTINUUM_SITE_URL + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: isAcademy,
        content: "creativecity",
        linkTo: REACT_APP_URL_CREATIVE_CITY || "",
        action: () => {
          if (REACT_APP_URL_CREATIVE_CITY) {
            window.open(REACT_APP_URL_CREATIVE_CITY + suffix, "_self");
          }
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: true,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: isBrnd,
        content: "brnd",
        linkTo: "https://shop.brnd.ru/?page=1",
        action: () => {
          window.open("https://shop.brnd.ru/?page=1", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        externalLink: true,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isGallllery(),
        content: "gallllery",
        linkTo: REACT_APP_URL_GALLERY || "",
        action: () => {
          if (REACT_APP_URL_GALLERY) {
            window.open(REACT_APP_URL_GALLERY + suffix, "_self");
          }
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        externalLink: true,
      },
      {
        id: ContextCodes.dafes,
        active: isNewDafesSegment || AppTester.isContext("dafes"),
        content: "dafes",
        linkTo: REACT_APP_URL_DAFES || "",
        action: () => {
          if (REACT_APP_URL_DAFES) {
            window.open(REACT_APP_URL_DAFES + suffix, "_self");
          }
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
      },
    ];

    // Фильтруем по excludeIds
    const filterExcluded = (linksArray: any[]) => {
      if (excludeIds?.length === 0) return linksArray;
      return linksArray.filter(link => !excludeIds?.includes(link.content));
    };

    return [
      ...filterExcluded(mediiiaLinks).map((l) => {
        if (l?.disableTitleSuffix) {
          return { ...l, menuTitleSuffix: "" as const }
        }
        return (
          { ...l, menuTitleSuffix: "mediiia" as const }
        )
      }),
      ...(onlyMediiia ? [] : filterExcluded(deziiignLinks).map((l) => {
        let finalSuffix = l?.importantTitle || 'deziiign';
        return { ...l, menuTitleSuffix: finalSuffix }
      })),
      ...(onlyMediiia ? [] : filterExcluded(tailLinks).map((l) => ({ ...l, menuTitleSuffix: "" as const }))),
    ];
  }, [
    baseURL,
    educationUrl,
    history,
    isBrnd,
    isContinuumSite,
    isDeziiignMain,
    isFashionDeziiign,
    isGameDeziiign,
    isLectureMediiia,
    isMediiiaMain,
    isMediiiaUrban,
    isMyMediiia,
    isNewDafesSegment,
    isProDeziiign,
    myMediiiaUrl,
    pathname,
    REACT_APP_URL_CREATIVE_CITY,
    REACT_APP_URL_DAFES,
    REACT_APP_URL_DEZIIIGN,
    REACT_APP_URL_DEZIIIGN_FASHION_COM,
    REACT_APP_URL_DEZIIIGN_GAME_COM,
    REACT_APP_URL_DEZIIIGN_PRO_COM,
    REACT_APP_URL_DEZIIIGN_URBAN_COM,
    REACT_APP_URL_GALLERY,
    sportMediiiaUrl,
    suffix,
    isDeziiignMain,
  ]);

  return {
    links,
    modalSettings: {
      titleColor: (isGameDeziiign || isContinuumSite || isAcademy) ? "#FEFEFE" : "#151514",
      title: isMediaCtxs ? "mediiia" : "deziiign",
    },
  };
};
import { ContextCodes } from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import { useHistory, useLocation } from "react-router-dom";
import { AuthXService } from "@brg/auth";
import { useMemo } from "react";
import { AppTester } from "../../../../supporting";

const CONTINUUM_SITE_URL = "https://continuum.site";

interface UseGetNewContextsLinksProps {
  onlyMediiia?: boolean;
  excludeIds?: string[];
}

export const useGetNewContextsLinks = (props?: UseGetNewContextsLinksProps) => {
  const { onlyMediiia = false, excludeIds } = props || {};
  const {
    isDeziiignMain,
    isFashionDeziiign,
    isGameDeziiign,
    isProDeziiign,
    isMediiiaUrban,
    isMediiia,
    isContinuumSite,
    isBrnd,
    isAcademy,
    isNewDafesSegment,
  } = useAppTester();


  const isMediaCtxs =
    AppTester.isContext("creativemediiia") ||
    AppTester.isContext("historymediiia") ||
    AppTester.isContext("profmediiia") ||
    AppTester.isContext("gamemediiia") ||
    AppTester.isContext("cinemediiia") ||
    AppTester.isContext("aimediiia") ||
    AppTester.isContext("sportmediiia") ||
    AppTester.isContext("eventmediiia") ||
    AppTester.isContext("transfermediiia") ||
    AppTester.isContext("musicmediiia") ||
    AppTester.isContext("storiesmediiia") ||
    AppTester.isContext("artmediiia") ||
    AppTester.isContext("fairmediiia") ||
    AppTester.isContext("admediiia") ||
    AppTester.isContext("kiiidsmediiia") ||
    AppTester.isContext("automediiia") ||
    AppTester.isContext("designmediiia") ||
    AppTester.isContext("urbanmediiia") ||
    AppTester.isContext("fashionmediiia") ||
    AppTester.isContext("foodmediiia") ||
    AppTester.isContext("booksmediiia") ||
    AppTester.isContext("lmsmediiia") ||
    AppTester.isContext("naturemediiia") ||
    AppTester.isContext("conceptmediiia") ||
    AppTester.isContext("mymediiia");

  const isMediiiaMain = isMediiia && !isMediaCtxs;
  const isMyMediiia = AppTester.isMyMediiia();
  const isLectureMediiia = AppTester.isLectureMediiia();

  const {
    REACT_APP_URL_DEZIIIGN,
    REACT_APP_URL_DEZIIIGN_FASHION_COM,
    REACT_APP_URL_DEZIIIGN_GAME_COM,
    REACT_APP_URL_DEZIIIGN_PRO_COM,
    REACT_APP_URL_DEZIIIGN_URBAN_COM,
    REACT_APP_URL_MEDIIIA_COM,
    REACT_APP_URL_EDUCATION_MEDIIIA_COM,
    REACT_APP_URL_MY_MEDIIIA_COM,
    REACT_APP_URL_SPORT_MEDIIIA_COM,
    REACT_APP_URL_DAFES,
    REACT_APP_URL_CREATIVE_CITY,
    REACT_APP_URL_GALLERY,
  } = process.env;

  const suffix = AuthXService.isAuthenticated()
    ? "?shouldLogin=true&saveLoginUrl=true"
    : "";
  const history = useHistory();
  const { pathname } = useLocation();

  const baseURL = REACT_APP_URL_MEDIIIA_COM || "";
  const educationUrl = REACT_APP_URL_EDUCATION_MEDIIIA_COM || "";
  const myMediiiaUrl = REACT_APP_URL_MY_MEDIIIA_COM || "";
  const sportMediiiaUrl = REACT_APP_URL_SPORT_MEDIIIA_COM || "";
  const mediaMainTab = sessionStorage.getItem('mediaMainTab')
  const links = useMemo(() => {
    const mediiiaLinks = [
      {
        id: ContextCodes.hseDesignMain,
        active: ["/", "/portfolio"].includes(pathname) && isMediiiaMain,
        content: "main",
        linkTo: "/",
        action: () => {
          if (isMediiiaMain && !mediaMainTab) {
            history.push("/");
            return;
          }
          if (isMediiiaMain && mediaMainTab) {
            window.location.href = `/?tab=${mediaMainTab}`;
            return;
          }
          if (mediaMainTab) {
                window.open(baseURL + `/?tab=${mediaMainTab}`, "_self");
                return;
          }
          window.open(baseURL + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: isMyMediiia,
        content: "my",
        linkTo: `${myMediiiaUrl}`,
        action: () => {
          window.open(myMediiiaUrl + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: true,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("artmediiia") || AppTester.isContext("fairmediiia"),
        content: "art",
        linkTo: `${baseURL}/art`,
        action: () => {
          window.open(baseURL + "/art", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("historymediiia"),
        content: "history",
        linkTo: `${baseURL}/history`,
        action: () => {
          window.open(baseURL + "/history", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("booksmediiia"),
        content: "books",
        linkTo: `${baseURL}/books`,
        action: () => {
          window.open(baseURL + "/books", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("musicmediiia"),
        content: "sound",
        linkTo: `${baseURL}/sound`,
        action: () => {
          window.open(baseURL + "/sound", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("cinemediiia"),
        content: "cine",
        linkTo: `${baseURL}/cine`,
        action: () => {
          window.open(baseURL + "/cine", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("admediiia"),
        content: "advert",
        linkTo: `${baseURL}/advert`,
        action: () => {
          window.open(baseURL + "/advert", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("conceptmediiia"),
        content: "concept",
        linkTo: `${baseURL}/concept`,
        action: () => {
          window.open(baseURL + "/concept", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("sportmediiia"),
        content: "sport",
        linkTo: `${sportMediiiaUrl}`,
        action: () => {
          window.open(sportMediiiaUrl + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: true,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("eventmediiia"),
        content: "365",
        linkTo: `${baseURL}/365`,
        action: () => {
          window.open(baseURL + "/365", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("naturemediiia"),
        content: "astro",
        linkTo: `${baseURL}/astro`,
        action: () => {
          window.open(baseURL + "/astro", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("foodmediiia"),
        content: "food",
        linkTo: `${baseURL}/food`,
        action: () => {
          window.open(baseURL + "/food", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("automediiia"),
        content: "auto",
        linkTo: `${baseURL}/auto`,
        action: () => {
          window.open(baseURL + "/auto", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("storiesmediiia"),
        content: "stories",
        linkTo: `${baseURL}/stories`,
        action: () => {
          window.open(baseURL + "/stories", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: isLectureMediiia,
        content: "education",
        linkTo: `${educationUrl}`,
        action: () => {
          window.open(educationUrl + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: true,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("aimediiia"),
        content: "ai",
        linkTo: `${baseURL}/ai`,
        action: () => {
          window.open(baseURL + "/ai", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("kiiidsmediiia"),
        content: "kiiids",
        linkTo: `${baseURL}/kiiids`,
        action: () => {
          window.open(baseURL + "/kiiids" + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("profmediiia"),
        content: "work",
        linkTo: `${baseURL}/work`,
        action: () => {
          window.open(baseURL + "/work", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: false,
      },
    ];

    const deziiignLinks = [
      {
        id: ContextCodes.deziiignMain,
        active: isDeziiignMain,
        content: "deziiign",
        importantTitle: "mediiia",
        linkTo: (REACT_APP_URL_DEZIIIGN || "") + suffix,
        action: () => {
          if (isDeziiignMain) {
            history.push("/");
            return;
          }
          window.open((REACT_APP_URL_DEZIIIGN || "") + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
      },
      {
        id: ContextCodes.fashionDeziiign,
        active: isFashionDeziiign,
        content: "fashion",
        linkTo: (REACT_APP_URL_DEZIIIGN_FASHION_COM || "") + suffix,
        action: () => {
          if (isFashionDeziiign) {
            history.push("/");
            return;
          }
          window.open((REACT_APP_URL_DEZIIIGN_FASHION_COM || "") + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isContext("urbanmediiia"),
        content: "urban",
        linkTo: (REACT_APP_URL_DEZIIIGN_URBAN_COM || "") + suffix,
        action: () => {
          if (isMediiiaUrban) {
            history.push("/");
            return;
          }
          window.open((REACT_APP_URL_DEZIIIGN_URBAN_COM || "") + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
      },
      {
        id: ContextCodes.gameDeziiign,
        active: isGameDeziiign,
        content: "game",
        linkTo: (REACT_APP_URL_DEZIIIGN_GAME_COM || "") + suffix,
        action: () => {
          if (isGameDeziiign) {
            history.push("/");
            return;
          }
          window.open((REACT_APP_URL_DEZIIIGN_GAME_COM || "") + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
      },
      {
        id: ContextCodes.proDeziiign,
        active: isProDeziiign,
        content: "pro",
        linkTo: (REACT_APP_URL_DEZIIIGN_PRO_COM || "") + suffix,
        action: () => {
          if (isProDeziiign) {
            history.push("/");
            return;
          }
          window.open((REACT_APP_URL_DEZIIIGN_PRO_COM || "") + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
      },
    ];

    const tailLinks = [
      {
        id: ContextCodes.hseVisualResearch,
        active: isContinuumSite,
        content: "continuum",
        linkTo: CONTINUUM_SITE_URL,
        action: () => {
          window.open(CONTINUUM_SITE_URL + suffix, "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: isAcademy,
        content: "creativecity",
        linkTo: REACT_APP_URL_CREATIVE_CITY || "",
        action: () => {
          if (REACT_APP_URL_CREATIVE_CITY) {
            window.open(REACT_APP_URL_CREATIVE_CITY + suffix, "_self");
          }
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        hidden: false,
        externalLink: true,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: isBrnd,
        content: "brnd",
        linkTo: "https://shop.brnd.ru/?page=1",
        action: () => {
          window.open("https://shop.brnd.ru/?page=1", "_self");
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        externalLink: true,
      },
      {
        id: ContextCodes.hseVisualResearch,
        active: AppTester.isGallllery(),
        content: "gallllery",
        linkTo: REACT_APP_URL_GALLERY || "",
        action: () => {
          if (REACT_APP_URL_GALLERY) {
            window.open(REACT_APP_URL_GALLERY + suffix, "_self");
          }
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
        externalLink: true,
      },
      {
        id: ContextCodes.dafes,
        active: isNewDafesSegment || AppTester.isContext("dafes"),
        content: "dafes",
        linkTo: REACT_APP_URL_DAFES || "",
        action: () => {
          if (REACT_APP_URL_DAFES) {
            window.open(REACT_APP_URL_DAFES + suffix, "_self");
          }
        },
        target: "_self",
        level: 1,
        hasChildren: true,
        hasCornerArrow: false,
      },
    ];

    // Фильтруем по excludeIds
    const filterExcluded = (linksArray: any[]) => {
      if (excludeIds?.length === 0) return linksArray;
      return linksArray.filter(link => !excludeIds?.includes(link.content));
    };

    return [
      ...filterExcluded(mediiiaLinks).map((l) => {
        if (l?.disableTitleSuffix) {
          return { ...l, menuTitleSuffix: "" as const }
        }
        return (
          { ...l, menuTitleSuffix: "mediiia" as const }
        )
      }),
      ...(onlyMediiia ? [] : filterExcluded(deziiignLinks).map((l) => {
        let finalSuffix = l?.importantTitle || 'deziiign';
        return { ...l, menuTitleSuffix: finalSuffix }
      })),
      ...(onlyMediiia ? [] : filterExcluded(tailLinks).map((l) => ({ ...l, menuTitleSuffix: "" as const }))),
    ];
  }, [
    baseURL,
    educationUrl,
    history,
    isBrnd,
    isContinuumSite,
    isDeziiignMain,
    isFashionDeziiign,
    isGameDeziiign,
    isLectureMediiia,
    isMediiiaMain,
    isMediiiaUrban,
    isMyMediiia,
    isNewDafesSegment,
    isProDeziiign,
    myMediiiaUrl,
    pathname,
    REACT_APP_URL_CREATIVE_CITY,
    REACT_APP_URL_DAFES,
    REACT_APP_URL_DEZIIIGN,
    REACT_APP_URL_DEZIIIGN_FASHION_COM,
    REACT_APP_URL_DEZIIIGN_GAME_COM,
    REACT_APP_URL_DEZIIIGN_PRO_COM,
    REACT_APP_URL_DEZIIIGN_URBAN_COM,
    REACT_APP_URL_GALLERY,
    sportMediiiaUrl,
    suffix,
    isDeziiignMain,
  ]);

  return {
    links,
    modalSettings: {
      titleColor: (isGameDeziiign || isContinuumSite || isAcademy) ? "#FEFEFE" : "#151514",
      title: isMediaCtxs ? "mediiia" : "deziiign",
    },
  };
};
